import {useEffect} from 'react'
import { Navbar,Container,Nav,Dropdown,Image} from 'react-bootstrap'

import { Link } from 'react-router-dom'
import CustomToggle from '../../../dropdowns'
import {bindActionCreators} from "redux"
import { setNotificaionViewFalse } from '../../../../store/slices/costing/costingSlice'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useAuth0 } from '@auth0/auth0-react'

import NotificationHeaderList from '../../../cco/notifications/NotificationsHeaderList'


import "../../../../styles/header.css";
//img
import avatars1 from '../../../../assets/images/avatars/01.png'
// logo
import Logo from '../../components/logo'
import { openModal } from '../../../../store/slices/modal/modalSlice'
// store
import {NavbarstyleAction, getDirMode, SchemeDirAction,  getNavbarStyleMode, getSidebarActiveMode, SidebarActiveStyleAction, getDarkMode, ModeAction,  SidebarColorAction, getSidebarColorMode, getSidebarTypeMode} from '../../../../store/setting/setting'
import {connect,useDispatch,useSelector} from "react-redux"
import { getUser } from '../../../../store/slices/profile/profileThunks'
import { getEndDateTrialPlan } from '../../../../store/slices/auth/authThunks'

import { getJsonConfigsInDb } from '../../../../store/slices/roles/rolesThunks'
const mapStateToProps = (state) => {
    return {
        darkMode: getDarkMode(state),
        schemeDirMode: getDirMode(state),
        sidebarcolorMode: getSidebarColorMode(state),
        sidebarTypeMode: getSidebarTypeMode(state),
        sidebaractivestyleMode: getSidebarActiveMode(state),
        navbarstylemode: getNavbarStyleMode(state),
    };
}
const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(
        {
            ModeAction,
            SchemeDirAction,
            SidebarColorAction,
            SidebarActiveStyleAction,
            NavbarstyleAction,
        },
        dispatch
    )
})


const Header = (props) => {
    const dispatch = useDispatch();
    const  {user} = useSelector( (state) => state.profile );
    const { rolConfig } = useSelector((state) => state.roles);
    const { idTenant } = useSelector((state) => state.costing);
    const { endDateplan,datePlanStatus } = useSelector((state) => state.auth);
    const { notificationView } = useSelector((state) => state.costing);
   
    const emailTenant = useAuth0();
    const userAuth = useAuth0();
    const adminEmail = userAuth.user.email

    const {logout} = useAuth0()
    
    useEffect(()=> {
        dispatch(getJsonConfigsInDb())
     },[])
    useEffect(()=> {
        dispatch(getUser(emailTenant.user.email))
     },[])
     useEffect(()=> {

          dispatch(getEndDateTrialPlan(idTenant))
      
     },[idTenant])
    useEffect(() => {
         // navbarstylemode
         const navbarstyleMode1 = sessionStorage.getItem('Navbarstyle-mode');
         if(navbarstyleMode1===null){
             props.NavbarstyleAction(props.navbarstylemode);
         }
         else{
             props.NavbarstyleAction(navbarstyleMode1);
         }
  })


  const minisidebar =() =>{
        document.getElementsByTagName('ASIDE')[0].classList.toggle('sidebar-mini')
    }

 
    return (
        <>
            <Navbar expand="lg" variant="light" className="nav iq-navbar">



                <Container fluid className="navbar-inner">
                    <Link to="/" className="navbar-brand">
                        <Logo color={true} />
                        <h4 className="logo-title">Cloud Costing</h4>
                    </Link>
                    <div className="sidebar-toggle" data-toggle="sidebar" data-active="true" onClick={minisidebar}>
                        <i className="icon">
                            <svg width="20px" height="20px" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                            </svg>
                        </i>
                    </div>
                  
                    <Navbar.Toggle aria-controls="navbarSupportedContent">
                        <span className="navbar-toggler-icon">
                            <span className="mt-2 navbar-toggler-bar bar1"></span>
                            <span className="navbar-toggler-bar bar2"></span>
                            <span className="navbar-toggler-bar bar3"></span>
                        </span>
                    </Navbar.Toggle>
                    <Navbar.Collapse  id="navbarSupportedContent">                    
                        <Nav as="ul" className="mb-2 ms-auto navbar-list mb-lg-0">                   
                        {     endDateplan !== "false" &&       
                      (  <div style={{marginRight:'14px',marginTop:'15px',fontWeight:'8px'}}>
                             <p>Trial plan:{endDateplan} </p>
                             </div>)
                          
}

{
                   user && rolConfig?.VIEWS?.HOME?.CHANGE_TENANT.includes(user[0]?.iduserrole) &&(      

                    <div  onClick={() => { dispatch(openModal('SuperAdminStatus')) }} style={{ marginTop:'5px', cursor: 'pointer',height:'40px',display: 'flex', alignItems: 'center',borderRadius:'5px',border: '2px solid #899AF1'}}>

            {     user && user.map((item) =>   ( <h5 className="mb-0 caption-title" style={{ marginLeft: '5px', fontSize: '15px'  }}>Current Tenant:  { item.tenantname}</h5>
            ))
            }
                    
                    <Dropdown className="nav-item" style={{ marginLeft: '10px' }}>
                      <div  style={{ cursor: 'pointer', marginBottom:'8px',marginTop:'8px' }}>
                        <AdminPanelSettingsIcon style={{ fontSize: '3rem' }} />
                      </div>
                    </Dropdown>
                  </div>
                          
                                 
                                 
                                 
                                 
                                 )
                               
                            }
                           
                            
                      {/*                             
                            <Dropdown as="li" className="nav-item">

                                <Dropdown.Toggle as={CustomToggle}   variant="search-toggle nav-link">
                                    <img src={flag1} className="img-fluid rounded-circle" alt="user" style={{height: "30px", minWidth: "30px", width: "30px",}}/>
                                    <span className="bg-primary"></span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="p-0 sub-drop dropdown-menu-end">
                                    <div className="m-0 border-0 shadow-none card">
                                        <div className="p-0 ">
                                            <ul className="list-group list-group-flush">
                                                <li className="iq-sub-card list-group-item"><Link className="p-0" to="#"><img src={flag3} alt="img-flaf" className="img-fluid me-2" style={{width: "15px", height: "15px", minWidth: "15px",}}/>Spanish</Link></li>                                          
                                                <li className="iq-sub-card list-group-item"><Link className="p-0" to="#"><img src={flag1} alt="img-flaf" className="img-fluid me-2" style={{width: "15px", height: "15px", minWidth: "15px",}}/>English</Link></li>
                                               
                                            </ul>
                                        </div>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown> */}
                            
                       

                            <Dropdown as="li" className="nav-item" onClick={()=>{dispatch(setNotificaionViewFalse())}}>
                                <Dropdown.Toggle as={CustomToggle}    variant=" nav-link" id="notification-drop" data-bs-toggle="dropdown" >
                                    <svg width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.7695 11.6453C19.039 10.7923 18.7071 10.0531 18.7071 8.79716V8.37013C18.7071 6.73354 18.3304 5.67907 17.5115 4.62459C16.2493 2.98699 14.1244 2 12.0442 2H11.9558C9.91935 2 7.86106 2.94167 6.577 4.5128C5.71333 5.58842 5.29293 6.68822 5.29293 8.37013V8.79716C5.29293 10.0531 4.98284 10.7923 4.23049 11.6453C3.67691 12.2738 3.5 13.0815 3.5 13.9557C3.5 14.8309 3.78723 15.6598 4.36367 16.3336C5.11602 17.1413 6.17846 17.6569 7.26375 17.7466C8.83505 17.9258 10.4063 17.9933 12.0005 17.9933C13.5937 17.9933 15.165 17.8805 16.7372 17.7466C17.8215 17.6569 18.884 17.1413 19.6363 16.3336C20.2118 15.6598 20.5 14.8309 20.5 13.9557C20.5 13.0815 20.3231 12.2738 19.7695 11.6453Z" fill="currentColor"></path>
                                        <path opacity="0.4" d="M14.0088 19.2283C13.5088 19.1215 10.4627 19.1215 9.96275 19.2283C9.53539 19.327 9.07324 19.5566 9.07324 20.0602C9.09809 20.5406 9.37935 20.9646 9.76895 21.2335L9.76795 21.2345C10.2718 21.6273 10.8632 21.877 11.4824 21.9667C11.8123 22.012 12.1482 22.01 12.4901 21.9667C13.1083 21.877 13.6997 21.6273 14.2036 21.2345L14.2026 21.2335C14.5922 20.9646 14.8734 20.5406 14.8983 20.0602C14.8983 19.5566 14.4361 19.327 14.0088 19.2283Z" fill="currentColor"></path>
                                    </svg>
                                    {/* <span className="bg-danger dots  active" ></span> */}
                                    <span className={`bg-danger dots ${notificationView ? 'active' : ''}`}></span>

                                </Dropdown.Toggle>
                                <Dropdown.Menu className="p-0 sub-drop dropdown-menu-end" aria-labelledby="notification-drop">
                                    <NotificationHeaderList/>
                                </Dropdown.Menu>
                            </Dropdown>
                           
                            <Dropdown as="li" className="nav-item">
                                <Dropdown.Toggle as={CustomToggle} variant=" nav-link py-0 d-flex align-items-center" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                
                                                                                {
                             user ? user.map((item) => {
                                   return (
                                   item.userprofile ? (
                                    <Image src={item.userprofile} alt="User-Profile" className="theme-color-default-img img-fluid avatar avatar-50 avatar-rounded"/>
                                   ) : (
                                     <Image src={avatars1} alt="User-Profile" className="theme-color-default-img img-fluid avatar avatar-50 avatar-rounded"/>
                                 )
                                  );
                            }) : (
                                <Image src={avatars1} alt="User-Profile" className="theme-color-default-img img-fluid avatar avatar-50 avatar-rounded"/>
                               )
                               }
                
                                        {
                                            user.map((item) => {
                                                return (
                                                    <div className="caption ms-3 d-none d-md-block ">
                                                    <h6 className="mb-0 caption-title">{item.name} {item.lastname}</h6>
                                                    <p className="mb-0 caption-sub-title">{ item.iduserrole === 0 ? 'SuperAdmin' : 
                                                         item.iduserrole === 1 ? 'Admin' : 
                                                         item.iduserrole === 2 ? 'Costing Explorer' :
                                                         item.iduserrole === 3 ? 'Read Only' : '' }</p>
                                    </div>
                                                );
                                            }
                                            
                                            )


                                        }                                      
                                </Dropdown.Toggle>
                                <Dropdown.Menu  className="dropdown-menu-end" aria-labelledby="navbarDropdown">
                                    <Dropdown.Item  as={Link} to="/profile" >Profile</Dropdown.Item>





                                    {/* <Dropdown.Item href="">Privacy Setting</Dropdown.Item> */}
                                    <Dropdown.Item onClick={()=>{dispatch(openModal('About'))}} >About</Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={()=>{logout({ returnTo:'window.location.origin' } )}}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
